<template>
  <slot v-bind="{ visible, tags }"  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProductsStore } from '@/stores'
const store = useProductsStore()

const props = defineProps<{
  tags: string[]
  bundleProductId: number
  productHandle: string
  productId: number
}>()

const visible = computed(() => store.filter === 'all' || props.tags.includes(store.filter))
</script>
